import { useNavigate } from 'react-router-dom';
import RadioButton from '../../components/radioButton/radioButton';
import styles from './govEntityStep.module.css';
import Tooltip from '../../components/tooltip/tooltip';
import InfoIcon from '../../../img/icons/info.svg';

export default function GovEntityStep ({ formData, setFormData }) {
  const navigate = useNavigate();

  const handleChange = (val, isUnselect) => {
    // Update form
    setFormData((prevData) => ({
      ...prevData,
      govEntityStep: {
        isGovEntity: val,
        isValid: isUnselect
      }
    }));

    // Update url params
    const searchParams = new URLSearchParams(window.location.search);
    const newParam = val.find(
      (description) => description.isChecked === true
    ).value;
    searchParams.set('g', newParam);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headingAndTooltipContainer}>
        <h2>
          {formData.providerStep.provider === 'other'
            ? (
                'Is this service delivered by a government entity?')
            : (
                'Are you a government entity?'
              )}
        </h2>
        <Tooltip
          content={
            <p style={{ padding: '7px 12px', fontSize: '12.8px' }}>
              Government Entity is a state or territory government provider.
              This does not include a local government provider.
            </p>
              }
          icon={<InfoIcon className={styles.infoIcon} />}
          isHover={false}
          showToolTipArrow={false}
          positionX='centre'
        />
      </div>

      <p className={styles.description}>
        Some requirements differ for state or territory government providers.
      </p>
      <p className={styles.selectText}>Select yes or no</p>
      <div className={styles.contentContainer}>
        <RadioButton
          options={formData.govEntityStep.isGovEntity}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
}
